<template>
  <fieldset id="catalogFilters" class="border-0 mb-4 p-0 border-b border-balternative-color px-6">
    <div class="grid grid-cols-2 mb-2">
      <div class="text-xl text-pdsPrimaryColor">Filters</div>
      <div class="text-end">
        <ChevronDownIcon
          @click.prevent="toggleDetails()"
          v-if="!collapsed"
          class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor-pointer"
          aria-hidden="true"
        />
        <ChevronUpIcon
          @click.prevent="toggleDetails()"
          v-else
          class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor-pointer"
          aria-hidden="true"
        />
      </div>
    </div>
    <div v-if="!collapsed" class="mb-4">
      <v-checkbox-group
        class="mb-2"
        v-for="(filter, index) in filters"
        :key="index"
        :label="filter.label"
        :inputid="'filter' + index"
        :initvalue="selected.indexOf(filter) > -1"
        :overwrite-value="selected.indexOf(filter) > -1"
        @update="change(filter, $event)"
      >
        <VTooltip
          v-if="filter.label === 'Mediq Select'"
          placement="top"
          :triggers="['hover', 'focus']"
          :popperTriggers="['hover', 'focus']"
          :delay="{ show: 100, hide: 2000 }"
          popper-class="mediq-select-tooltip"
        >
          <button
            type="button"
            class="mediq-select-filter-info"
            aria-label="Mediq Select informatie"
            @click.prevent.stop
            @mousedown.prevent.stop
          >
            <InformationCircleIcon class="h-4 w-4" aria-hidden="true" />
          </button>
          <template #popper>
            {{ MEDIQ_SELECT_INFO_TEXT }}
            <a
              :href="MEDIQ_SELECT_INFO_URL"
              target="_blank"
              rel="noopener noreferrer"
              class="mediq-select-tooltip__link"
              @click.stop
            >
              Lees meer
            </a>
          </template>
        </VTooltip>
      </v-checkbox-group>
    </div>
  </fieldset>
</template>

<script>
import VCheckboxGroup from './CheckboxGroup';
import { ChevronDownIcon, ChevronUpIcon, InformationCircleIcon } from '@heroicons/vue/20/solid';
import { Tooltip as VTooltip } from 'floating-vue';
import { useResponsiveCollapse } from '@/composables/useResponsiveCollapse';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
import { MEDIQ_SELECT_INFO_TEXT, MEDIQ_SELECT_INFO_URL } from '@/constants/mediqSelect';

export default {
  name: 'VFilters',
  components: {
    VCheckboxGroup,
    ChevronDownIcon,
    ChevronUpIcon,
    InformationCircleIcon,
    VTooltip
  },
  props: {
    filters: Array,
    modelValue: {
      default: () => [],
      type: Array
    }
  },
  setup(props, { emit }) {
    const { collapsed } = useResponsiveCollapse();
    const selected = ref([]);
    const router = useRouter();

    const toggleDetails = () => {
      collapsed.value = !collapsed.value;
    };

    const change = (filter, active) => {
      if (active) {
        selected.value.push(filter);
      } else {
        const index = selected.value.findIndex((item) => item.label === filter.label);
        if (index !== -1) {
          selected.value.splice(index, 1);
        }
      }
      emit('update:modelValue', selected.value);
    };
    onMounted(() => {
      if (router.currentRoute.value.meta?.recentOrders) {
        selected.value.push(props.filters.find((filter) => filter.label === 'Eerder besteld voor patient'));
        emit('update:modelValue', selected.value);
      }
    });
    onBeforeUnmount(() => {
      selected.value = [];
    });

    return {
      selected,
      collapsed,
      toggleDetails,
      change,
      MEDIQ_SELECT_INFO_TEXT,
      MEDIQ_SELECT_INFO_URL
    };
  }
};
</script>
<style lang="scss" scoped>
:deep(.v-popper) {
  display: inline-flex;
  align-items: center;
}

.mediq-select-filter-info {
  display: inline-flex;
  align-items: center;
  margin-left: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: $petrol-700;
  fill: $petrol-700;
  cursor: help;
  vertical-align: middle;
  line-height: 0;
}
</style>
